import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {  ProgramStatusService } from '@ebb-v2/ebb-integration';
import { AccountsService } from './modules/registration/services/accounts/accounts.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'hom-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class HomeownerAppComponent {
  public programTypeCodeOptionSet: string;
  public unsupportedBrowser = false;
  public supportedBrowsers = ['chrome', 'edge', 'safari'];
  constructor(private accountsService: AccountsService,
    private router: Router,
    
    private programstatus:ProgramStatusService,    private readonly deviceService: DeviceDetectorService
    ){

    }
    public ngOnInit(): void {
      const browserName = this.deviceService.browser.toLowerCase();
      this.unsupportedBrowser = !this.supportedBrowsers.some(browser =>
        browserName.includes(browser)
      );
      this.programTypeCodeOptionSet = this.accountsService.programTypeCodeOptionSet;
      this.programstatus.checkProgramstatus(this.programTypeCodeOptionSet).subscribe((data) => {
        if(!data){
          var ProgramType =this.programTypeCodeOptionSet;
          if(ProgramType.includes("FEMA") || ProgramType.includes("EBB"))  {
            ProgramType = "ebb";
          }
          if(ProgramType.includes("ESS"))  {
            ProgramType = "ess";
          }
          if(ProgramType.includes("CEA BB"))  {
            ProgramType = "ceabb";
          }
          if(ProgramType.includes("EMR"))  {
            ProgramType = "emr";
          }
          this.router.navigate(['status', ProgramType]);
        }
        })}
       
 }
 


